import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { setImpersonationToken } from '@/lib/api';
import styles from '../components/layout/AppShell.module.css';

export const Route = createFileRoute('/auth/impersonate')({
  component: ImpersonatePage,
});

function ImpersonatePage() {
  const navigate = useNavigate();
  const search = new URLSearchParams(window.location.search);
  const token = search.get('token');

  useEffect(() => {
    if (!token) {
      navigate({ to: '/login' });
      return;
    }
    // Store token in sessionStorage — scoped to this tab only
    setImpersonationToken(token);
    // Clean the URL so the token isn't visible in browser history
    window.history.replaceState({}, '', '/dashboard');
    // Hard navigate to dashboard so AuthContext re-mounts and picks up the token
    window.location.href = '/dashboard';
  }, [token, navigate]);

  return (
    <div className={`${styles.loadingScreen} ${styles.loadingScreenSupport}`}>
      <div className={styles.loadingLogo}>e</div>
      <p className={styles.loadingTitle}>Starting support session</p>
      <p className={styles.loadingSubtitle}>Validating impersonation token…</p>
      <div className={styles.loadingSpinner} />
      <div className={styles.loadingSteps}>
        <div className={styles.loadingStep}>
          <span className={styles.loadingStepDot} />
          Authenticating token
        </div>
        <div className={styles.loadingStep}>
          <span className={styles.loadingStepDot} />
          Resolving tenant
        </div>
        <div className={styles.loadingStep}>
          <span className={styles.loadingStepDot} />
          Redirecting to dashboard
        </div>
      </div>
    </div>
  );
}
